import React from "react";
import {cn} from "../../utils/cn";

/**
 * Simple controlled tab bar that matches the design system.
 *
 *   <Tabs value={value} onChange={setValue} items={[
 *     {value: "list",   label: "Task List",   icon: ListChecks},
 *     {value: "create", label: "Create",      icon: FilePen},
 *   ]} />
 *
 * The active state uses a 2px bottom border in brand-700 + matching
 * text color, consistent with Radix Tabs spec'd in Phase 3.
 */
export default function Tabs({value, onChange, items = [], className}) {
  return (
    <div className={cn("border-b border-ink-200", className)} role="tablist">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8 flex items-center gap-1 overflow-x-auto">
        {items.filter((i) => i && !i.hidden).map((item) => {
          const active = value === item.value;
          const Icon = item.icon;
          return (
            <button
              key={item.value}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange && onChange(item.value)}
              className={cn(
                "h-11 px-3 inline-flex items-center gap-2",
                "text-base font-medium border-b-2 -mb-px",
                "transition-colors duration-fast whitespace-nowrap",
                active
                  ? "text-brand-700 border-brand-700"
                  : "text-ink-500 hover:text-ink-900 border-transparent"
              )}
            >
              {Icon && <Icon className="h-4 w-4" aria-hidden="true" />}
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
